import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../../utils/api';
import { fmtDateTime } from './FicheKit';

// 01.7 — Cloche : « [Plat] · v[n] par [nom] : [changement] · coût ±x · coût matière x % → y % » ; un clic ouvre la fiche avec le changement surligné.
export const chargerNotifsFiches = () => axios.get(`${getApiUrl()}/fiches-techniques/notifications/mes`, { withCredentials: true }).then((r) => r.data).catch(() => ({ items: [], non_lues: 0 }));

export const FicheNotifications = ({ tenantSlug, onRead }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    chargerNotifsFiches().then((d) => {
      setItems(d.items || []);
      if (d.non_lues) axios.post(`${getApiUrl()}/fiches-techniques/notifications/lues`, {}, { withCredentials: true }).then(() => onRead?.(d.non_lues)).catch(() => {});
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items?.length) return null;
  return (
    <section className="ft-notifs" data-testid="ft-notifications">
      <h4>Fiches techniques</h4>
      {items.slice(0, 12).map((n) => <button key={n.notif_id} type="button" className={`ft-notif ${n.lu ? '' : 'is-new'} ${n.prioritaire ? 'is-prio' : ''}`} data-testid={`ft-notif-${n.notif_id}`}
        onClick={() => navigate(n.path || `/${tenantSlug}/recettes-couts/${n.slug || n.fiche_id}${n.highlight?.length ? `?highlight=${n.highlight.join(',')}` : ''}`)}>
        <span className="ft-notif-txt">{n.texte}</span>
        <small>{fmtDateTime(n.at)}{n.prioritaire ? ' · allergènes · prioritaire' : ''}{n.urgent ? ' · WhatsApp / e-mail' : ''}</small>
      </button>)}
    </section>
  );
};
